import { createBrowserHistory } from 'history'
import _ from 'lodash'
import { createContext, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Route, Router, Switch } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { analyticsBiEvent, analyticsPageViewEvent } from 'analytics/actions'
import { ThemeProvider } from 'common-components'
// eslint-disable-next-line import/no-named-as-default
import AppUpdating from 'common-components/app-updating'
import { isLoggedIn } from 'identity/selectors'
import { asyncComponent } from 'lib/async'
import { reloadApplicationRequest, updateApplicationRequest } from 'quick-quote/actions'
import { ROUTE_PATH } from 'quick-quote/constants/path'
import { clearNotificationMessage } from 'quick-quote/notification/actions'
import { getApplicationStatus, getVersion, isSelectedRemoteSelling, getEnableMaPage } from 'quick-quote/selectors'

import { clickHomeButton } from './actions'
import { GlobalPopup, MainLayout, NavigationButton, ScrollToTop, SplashScreen } from './components'
import QuickQuoteRoutes from './components/navigations/routes'
import RequireAmlo from './components/navigations/require-amlo'
import AuthenticationError from 'quick-quote/components/authentication-error-keycloak'
import AuthenticationInfo from 'quick-quote/components/authentication-user-infomations'
import MaintenancePage from 'quick-quote/components/maintenance-page'

let ESubmission = asyncComponent(() => import(/* webpackChunkName: "e-submission-app" */ 'e-submission/app'))
if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
  ESubmission = require('e-submission/app').default
}

export const PagesContext = createContext(() => null)
export const NextButtonContext = createContext(() => null)

const MainWithoutRouter = ({
  nextButton,
  isLoggedIn,
  status,
  reloadApplicationRequest,
  updateApplicationRequest,
  version,
  dispatchAnalyticsBiEvent,
  dispatchAnalyticsPageViewEvent,
  globalMessage,
  clearNotificationMessage,
  handleHomeButtonClick,
  selectedRemoteSelling,
  inCall,
  enableMaPage,
  enableRetrieveCustomerPolicy,
  ...props
}) => {
  const [pages, setPages] = useState()
  return (
    <PagesContext.Provider value={setPages}>
      <ThemeProvider>
        <MainLayout
          version={version}
          onBackToHome={handleHomeButtonClick}
          selectedRemoteSelling={selectedRemoteSelling}
          inCall={inCall}
          pages={pages}
          setPages={setPages}
          enableMaPage={enableMaPage}
          enableRetrieveCustomerPolicy={enableRetrieveCustomerPolicy}
        >
          <AppUpdating />
          <GlobalPopup notificationMessage={globalMessage} onExit={clearNotificationMessage} />
          <ScrollToTop>
            <Switch>
              <Route
                path={'/authorize/error'}
                component={(props) => <AuthenticationError onExit={() => {}} notificationMessage={'test'} />}
              />
              <Route
                path={'/authorize/info'}
                component={(props) => <AuthenticationInfo onExit={() => {}} notificationMessage={'test'} />}
              />
              <Route
                path={'/authorize/ma'}
                component={(props) => <MaintenancePage onExit={() => {}} notificationMessage={'test'} />}
              />
              <Route
                path={ROUTE_PATH.ESUBMISSION}
                render={(props) => (
                  <RequireAmlo location={props.location}>
                    <ESubmission {...props} />
                  </RequireAmlo>
                )}
              />
              <Route component={QuickQuoteRoutes} />
            </Switch>
          </ScrollToTop>
          <NavigationButton nextButton={nextButton} />
        </MainLayout>
      </ThemeProvider>
    </PagesContext.Provider>
  )
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: isLoggedIn(state),
    status: getApplicationStatus(state),
    globalMessage: state.notificationMessage,
    version: getVersion(state),
    selectedRemoteSelling: false,
    inCall: false,
    enableMaPage: getEnableMaPage(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  reloadApplicationRequest: bindActionCreators(reloadApplicationRequest, dispatch),
  updateApplicationRequest: bindActionCreators(updateApplicationRequest, dispatch),
  dispatchAnalyticsBiEvent: bindActionCreators(analyticsBiEvent, dispatch),
  dispatchAnalyticsPageViewEvent: bindActionCreators(analyticsPageViewEvent, dispatch),
  clearNotificationMessage: bindActionCreators(clearNotificationMessage, dispatch),
  handleHomeButtonClick: bindActionCreators(clickHomeButton, dispatch),
})

const basePath = process.env.BASE_PATH
const MainWithRouter = ({
  history = createBrowserHistory({ basename: basePath }),
  isLoggedIn,
  status,
  reloadApplicationRequest,
  updateApplicationRequest,
  version,
  dispatchAnalyticsBiEvent,
  globalMessage,
  clearNotificationMessage,
  dispatchAnalyticsPageViewEvent,
  handleHomeButtonClick,
  selectedRemoteSelling,
  inCall,
}) => {

  const matchAuthorizeErrorPathPattern = /\/authorize\/error/g
  const pathName = _.get(history, 'location.pathname')

  useEffect(() => {
    const element = document.getElementById('splash-screen')
    if (element && document.body) {
      document.body.removeChild(element)
    }
  }, [])

  if (matchAuthorizeErrorPathPattern.test(pathName))
    return <AuthenticationError onExit={() => {}} notificationMessage={'test'} />

  const [nextButton, setNextButton] = useState()

  return (
    <Router history={history}>
      {status === 'ready' ? (
        <NextButtonContext.Provider value={setNextButton}>
          <MainWithoutRouter
            history={history}
            nextButton={nextButton}
            isLoggedIn={isLoggedIn}
            status={status}
            reloadApplicationRequest={reloadApplicationRequest}
            updateApplicationRequest={updateApplicationRequest}
            version={version}
            dispatchAnalyticsBiEvent={dispatchAnalyticsBiEvent}
            globalMessage={globalMessage}
            clearNotificationMessage={clearNotificationMessage}
            dispatchAnalyticsPageViewEvent={dispatchAnalyticsPageViewEvent}
            handleHomeButtonClick={handleHomeButtonClick}
            selectedRemoteSelling={selectedRemoteSelling}
            inCall={inCall}
          />
        </NextButtonContext.Provider>
      ) : (
        <SplashScreen
          loadingState={status}
          updateApplicationRequest={updateApplicationRequest}
          reloadApplicationRequest={reloadApplicationRequest}
        />
      )}
    </Router>
  )
}

export const MainContainer = connect(mapStateToProps, mapDispatchToProps)(MainWithRouter)
